export default __webpack_public_path__ + "media/images/onglet-dafb646b772bca6edeb3b3334535f7c5.png";